export const ADMIN_THEME_STORAGE_KEY = 'popadmin-theme';

export type AdminTheme = 'light' | 'dark';

const isAdminTheme = (value: string | null): value is AdminTheme => value === 'light' || value === 'dark';

export const getInitialAdminTheme = (): AdminTheme => {
  if (typeof window === 'undefined') {
    return 'light';
  }

  const storedTheme = window.localStorage.getItem(ADMIN_THEME_STORAGE_KEY);

  if (isAdminTheme(storedTheme)) {
    return storedTheme;
  }

  return 'light';
};

export const syncAdminTheme = (theme: AdminTheme) => {
  if (typeof document !== 'undefined') {
    document.body.dataset.adminTheme = theme;
    document.documentElement.dataset.adminTheme = theme;
  }

  if (typeof window !== 'undefined') {
    window.localStorage.setItem(ADMIN_THEME_STORAGE_KEY, theme);
  }
};
